var React = require('react');

function ZoomInInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8 6V8H6V10H8V12H10V10H12V8H10V6H8Z","fill":"white","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.6177 16.0319C13.078 17.2635 11.125 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 11.125 17.2635 13.078 16.0319 14.6177L19.7071 18.2929L18.2929 19.7071L14.6177 16.0319ZM16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9C2 5.13401 5.13401 2 9 2C12.866 2 16 5.13401 16 9Z","key":1})]);
}

ZoomInInline.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = ZoomInInline;

ZoomInInline.default = ZoomInInline;
